<script lang="ts">
	import { devices_settings } from 'src/stores/device-runtime/status';
	//Design system components
	import { Button, Radio, Text } from '@Shelly/shelly-design-system';
	//Helpers
	import { onSettingsResponse } from 'src/helpers/device_settings_helpers';
	import { get_mode, real_id } from 'src/helpers/interface_helpers';
	//Services
	import { gen2Request } from 'src/services/gen_2_http_reqs';
	import { format } from 'svelte-i18n';
	//Stores
	import {
		getDeviceStatus,
		readDeviceStatus,
		readDeviceSettings,
	} from 'src/stores/device-runtime/status-selectors';
	//Types
	import type { Device } from 'src/types/Device';
	import { devices_config } from '@devices/index';
	import { genCharArray } from 'src/helpers/utilities';

	$: statusStore = getDeviceStatus(device.id);
	export let device: Device;

	let settings = readDeviceSettings(device.id);
	let selected: string = settings['em:0']?.phase_selector;
	let cacheSelected: string = selected;
	let loading: boolean = false;
	const mode = get_mode(device, settings, $statusStore);
	const phasesNUmber = devices_config[device.type]?.modes?.[mode]?.phases;
	const phases = genCharArray(phasesNUmber);
	phases.push('all');
	const phasesTranslated = [];
	phases.forEach((p) => {
		if (p !== 'all') {
			phasesTranslated.push($format(`label_phase_${p}`));
		} else {
			phasesTranslated.push($format('option_command_all', { default: 'All' }));
		}
	});

	const changeMode: (mode: string) => void = (mode: string) => {
		selected = mode;
	};

	const setMode: () => Promise<void> = async () => {
		if (cacheSelected !== selected) {
			loading = true;
			const res = await gen2Request(device, 'em.SetConfig', {
				id: 0,
				config: { phase_selector: selected },
			});
			let response = onSettingsResponse(res, device);
			if (!response) {
				selected = cacheSelected;
			} else {
				cacheSelected = selected;
				settings['em:0'].phase_selector = selected;
				devices_settings.update_devices_settings(real_id(device.id), settings);
			}
			loading = false;
		}
	};
</script>

<Text class="mb-s" styleType="body-small"
	>{$format('led_phase_selector_description', {
		default: 'Select the electrical measure that controls the LED indicator.',
	})}</Text
>

{#each phases as phase, i}
	<Radio
		size="m"
		class="mb-s"
		bind:selected
		value={phase}
		on:click={() => changeMode(phase)}
		id="radio-17xen64"
	>
		{phasesTranslated[i]}
	</Radio>
{/each}
<Button size="m" width="full" {loading} on:click={setMode}>{$format('button_save')}</Button>
